<template>
  <Flickity
    ref="slider"
    class="rin-slider"
    :options="internalFlickityOptions">
    <slot></slot>
  </Flickity>
</template>

<script>
  import Vue from 'vue';
  import Flickity from 'vue-flickity';

  const autoPlayTiming = 5000;

  export default {
    components: { Flickity },
    data() {
      return {
        internalFlickityOptions: {},
      };
    },
    props: {
      amountOfSlides: {
        required: true,
        type: Number,
      },
      flickityOptions: {
        default: () => {
          return {
            adaptiveHeight: false,
            autoPlay: autoPlayTiming,
            cellAlign: `left`,
            prevNextButtons: false,
            wrapAround: true,
          };
        },
        type: Object,
      },
      sliderInitialized: {
        required: true,
        type: Boolean,
      },
    },
    mounted() {
      this.internalFlickityOptions = { ...this.flickityOptions };
      this.modifyFlickityOptions();
      window.addEventListener(`resize`, _.debounce(() => this.modifyFlickityOptions(), 250));
    },
    destroyed() {
      window.removeEventListener(`resize`, this.modifyFlickityOptions);
    },
    methods: {
      modifyFlickityOptions() {
        if(this.amountOfSlides > 4) {
          this.internalFlickityOptions.arrowShape = {
            x0: 0,
            x1: 45,
            x2: 60,
            x3: 15,
            y1: 50,
            y2: 50,
          };
          this.internalFlickityOptions.autoPlay = autoPlayTiming;
          this.internalFlickityOptions.prevNextButtons = true;
        } else if(matchMedia(`screen and (max-width: 1380px)`).matches) {
          this.internalFlickityOptions.autoPlay = autoPlayTiming;
        } else {
          this.internalFlickityOptions.autoPlay = false;
        }
        Vue.nextTick(() => {
          this.$refs.slider.rerender();
        });
      },
    },
    watch: {
      sliderInitialized: {
        handler() {
          if(this.sliderInitialized) {
            this.$refs.slider.resize();
          }
        },
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../../assets/styles/rin-variables';

  .rin-slider {
    width: 100%;

    ::v-deep .flickity-prev-next-button {
      background: transparent;
    }

    ::v-deep .flickity-prev-next-button.previous {
      left: -15px;

      @media (min-width: @mobile-threshold-max) {
        left: -5px;
      }
    }

    ::v-deep .flickity-prev-next-button.next {
      right: -15px;

      @media (min-width: @mobile-threshold-max) {
        right: -5px;
      }
    }
  }
</style>
